import clientAxios from './../../config/axios';

export const getAllDrawersDivisions = ({ filter }: any) => {
  const filterTmp = filter ?? '';
  const url = `/drawers_divisions?country=${process.env.REACT_APP_ENV_COUNTRY}${filterTmp}`;
  return clientAxios.get(url);
};
